import { Button, Collapse } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { CaretDownIcon, CaretUpIcon } from "@phosphor-icons/react";

import { GetQueueDriverPositionRaw } from "@/store/apis/nextcargo";

type OrderDetailsProps = {
  scheduling: GetQueueDriverPositionRaw["scheduling"];
};

export function OrderDetails({ scheduling }: OrderDetailsProps) {
  const [opened, { toggle }] = useDisclosure();

  const schedulingOrder = scheduling?.order;
  const orderItemName =
    schedulingOrder?.orderItem.reduce((item) => {
      return item;
    }).product.name ?? "N/A";

  const productValue = `${orderItemName} - ${scheduling?.qtyOrdered ?? 0}t`;

  return (
    <div className="mt-2 flex flex-col gap-2">
      <Button onClick={toggle} size="sm" rightSection={opened ? <CaretUpIcon weight="fill" /> : <CaretDownIcon weight="fill" />}>
        Detalhes do pedido
      </Button>

      <Collapse in={opened}>
        <div>
          <RowItem label="Pedido" value={schedulingOrder?.code} />

          <RowItem label="Transportadora" value={schedulingOrder?.shippingCompany.name} />

          <RowItem label="Destinatário" value={schedulingOrder?.customer.name} />

          <RowItem label="Município" value={schedulingOrder?.customer.city} />

          <RowItem label="Produto" value={productValue} />
        </div>
      </Collapse>
    </div>
  );
}

function RowItem({ label, value }: { label: string; value?: string | number }) {
  if (!value) return null;

  return (
    <div className="flex items-center gap-2">
      <p className="font-semibold">{label}:</p>
      <p>{value}</p>
    </div>
  );
}
